import { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import useFetch from "../../../../hooks/useFetch";
import ForbiddenMessage from "../../../Mensajes/ForbiddenMessage";
import SuccessMessage from "../../../Mensajes/SuccessMessage";
import ServerMessage from "../../../Mensajes/ServerMessage";

/**
 * TipoServicioCrear Component
 * @description: Componente que permite agregar un nuevo tipoServicio.
 * @date 6/12/2022.
 * @param Props Ninguno
 * @returns JSX de la tabla de tipoServicios.
 */

const TipoServicioCrear = () => {
  const [show, setShow] = useState(false);
  const { sendRequest, error, setError, serverMessage, setServerMessage } =
    useFetch();

  //Formulario
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: {
      nombre: "",
      revision: false,
      estatus: "1",
    },
  });

  //Función que hace el POST para crear el tipoServicio.
  const createTipoServicio = (data: any) => {
    sendRequest(
      {
        url: `/tipo_servicio`,
        method: "POST",
        body: data,
      },
      (variable: any) => {
        setShow(true);
        reset({
          nombre: "",
          revision: false,
          estatus: "1",
        });
      }
    );
  };

  return (
    <Container>
      <h1>Agregar tipo de servicio</h1>
      {/** Alerta de guardado */}
      {show && (
        <SuccessMessage
          header="Tipo de servicio agregado"
          body="El tipo de servicio  ha sido agregado de manera correcta."
          onCloseHandler={() => setShow(false)}
        />
      )}
      {/** Error del servidor */}
      {serverMessage && (
        <ServerMessage
          message={serverMessage}
          onCloseHandler={() => setServerMessage(undefined)}
        />
      )}
      {error === 403 && (
        <ForbiddenMessage onCloseHandler={() => setError(null)} />
      )}
      {/** Formulario */}
      <Form onSubmit={handleSubmit(createTipoServicio)}>
        <Row className="mb-3">
          <Form.Group as={Col} md="12" className="mb-3">
            <Form.Label>Nombre</Form.Label>
            <Controller
              name="nombre"
              control={control}
              rules={{
                required: true,
                maxLength: 200,
              }}
              render={({ field }) => {
                return (
                  <Form.Control
                    {...field}
                    onChange={(e) =>
                      field.onChange(e.target.value.toUpperCase())
                    }
                  />
                );
              }}
            />
            {errors.nombre && (
              <Form.Text style={{ color: "red" }}>
                El nombre es obligatorio y no puede ser mayor a 200 caracteres.
              </Form.Text>
            )}
          </Form.Group>
        </Row>
        <Form.Group className="mb-3">
          <Form.Check
            label="¿Este servicio es una revisión?"
            style={{ textAlign: "left" }}
            {...register("revision")}
          />
        </Form.Group>

        <Button
          style={{ backgroundColor: "#21618C", borderColor: "white" }}
          type="submit"
        >
          Guardar cambios
        </Button>
      </Form>
    </Container>
  );
};

export default TipoServicioCrear;
